import React from "react";

const CustomSolutions = () => {
  return (
    <div className="md:px-10 px-5 md:py-7 py-5 text-center max-w-[1280px] mx-auto">
      {/* Heading Section */}
      <h2 className="small:text-[39px] text-3xl font-medium text-[#F8A133]">Help</h2>
      <h1 className="samll:text-2xl text-xl md:text-3xl  font-medium  small:overflow-hidden small:whitespace-nowrap  small:animate-typing text-secondary">
        Creative  Agency Delivering
      </h1>
      <h1 className="text-2xl md:text-3xl  font-medium text-secondary">
        Custom Solutions
      </h1>

      {/* Card Section */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Card 1 */}
        <div className="bg-white border border-[#DEDEDE] rounded-lg shadow-lg p-6 text-left">
          <p className="text-white text-[27px] font-semibold text-stroke">
            1st
          </p>

          <h3 className="text-lg font-bold">
            Innovative Solutions for Your Business
          </h3>
          <div className="underline py-3">
            <img
              alt="underline"
              src={require("../../common/images/underline.png")}
              className="w-[78px] h-[5px]"
            />
          </div>
          <p className="text-gray-600 mt-2">
            We specialize in providing innovative tech solutions tailored to
            your business needs. Our team ensures seamless integration and
            top-tier performance to help you achieve your goals.
          </p>
        </div>

        {/* Card 2 */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 text-left">
          <p className="text-white text-[27px] font-semibold text-stroke">
            2nd
          </p>
          <h3 className="text-lg font-bold">Expert Guidance and Support</h3>
          <div className="underline py-3">
            <img
              alt="underline"
              src={require("../../common/images/underline.png")}
              className="w-[78px] h-[5px]"
            />
          </div>
          <p className="text-gray-600 mt-2">
            Our experienced team is ready to guide you through every step of
            your project. From development to deployment, we ensure your
            business stays ahead of the curve.
          </p>
        </div>

        {/* Card 3 */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 text-left">
          <p className="text-white text-[27px] font-semibold text-stroke">
            3rd
          </p>
          <h3 className="text-lg font-bold">Cutting-Edge Technology</h3>
          <div className="underline py-3">
            <img
              alt="underline"
              src={require("../../common/images/underline.png")}
              className="w-[78px] h-[5px]"
            />
          </div>
          <p className="text-gray-600 mt-2">
            We use the latest technology to deliver powerful, efficient, and
            scalable solutions. Your success is our priority.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomSolutions;
